/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */

import { styled, Typography } from '@mui/material';
import theme from '../../../../../Shared/Themes/theme';

interface ContainerProps {
  selectedRowCount?: number;
}

export const FacilityCoordinatesContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  marginTop: '4rem',
  flexWrap: 'wrap',
  [theme.breakpoints.down('laptop')]: {
    flexWrap: 'wrap',
  },
}));

export const SliderContainer = styled('div')(() => ({
  maxWidth: '100%',
  minWidth: 400,
  marginTop: '80px',
  paddingRight: '9.75rem',
}));

export const SaveButtonContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'flex-end',
  paddingRight: '9.75rem',
  paddingTop: '3rem',
  width: '100%',
}));

export const TurnGeoFenceOnContainer = styled('div')<ContainerProps>(({ selectedRowCount }) => ({
  maxWidth: selectedRowCount !== 1 ? 1200 : 'auto',
}));

export const TurnGeoFenceOffContainer = styled('div')(() => ({
  maxWidth: 800,
  marginLeft: '1.25rem',
  marginTop: '3.75rem',
}));

export const SearchBarContainer = styled('div')(() => ({
  position: 'absolute',
  top: '20%',
  left: '5%',
  borderRadius: '1rem',
  background: theme.palette.common.white,
}));

export const LocationCardContainer = styled('div')(() => ({
  position: 'absolute',
  top: '20%',
  right: '15%',
}));

export const HeaderContainer = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.h4?.fontSize,
  fontWeight: theme.typography.fontWeightMedium,
  lineHeight: '1.5rem',
  letterSpacing: '0.009375rem',
  color: theme.palette.text.primary,
}));

export const TextContainer = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.h4?.fontSize,
  fontWeight: theme.typography.fontWeightLight,
  lineHeight: '1.5rem',
  letterSpacing: '0.009375rem',
  color: theme.palette.text.secondary,
}));

export const RadioWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  opacity: 0.5,
  cursor: 'not-allowed',
}));

export const RadioLabel = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.h3?.fontSize,
  fontWeight: theme.typography.fontWeightBold,
}));

export const CancelButtonWrapper = styled('div')(() => ({
  marginRight: '2rem',
}));
